<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">LISTADO DE INSPECCIONES</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <modal-ayuda></modal-ayuda>
        <v-row class="ml-1 mr-1 mt-2" justify="center">
            <v-col>
                <v-data-table
                    :headers="encabezados"
                    :items="inspecciones"
                >
                    <template v-slot:item.todo="{ item }">
                        <v-btn color="blue" dense small @click="verTodo(item)"><v-icon dark> list</v-icon>Ver</v-btn>
                    </template>
                    <template v-slot:item.area="{ item }">
                        <v-btn color="cyan" dense small @click="verArea(item)"><v-icon dark>assignment</v-icon>Ver</v-btn>
                    </template>
                    <template v-slot:item.imprimir="{ item }">
                        <v-btn color="green" fab small dark @click="download(item)">EXCEL</v-btn>
                    </template>
                    <template v-slot:item.nc_area="{ item }">
                        <v-btn color="cyan" fab small dark @click="ncArea(item)">EXCEL</v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-dialog v-model="todoDialog" persistent max-width="90%">
            <v-card>
                <v-card-title>
                    <span  class="headline">No conformidades en inspección realizada el {{ insp_actual.fecha }}</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="todoDialog = false"
                    >
                        VOLVER
                    </v-btn>
                </v-card-actions>

                <v-card-text>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr width="100%">
                                    <th :width="item.width" v-for="item in todo_headers" :key="item.name">{{ item.text }}</th>
                                    <th width="10%" v-if="esDeCalidad == true">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(registro, index) in registros" :key="index" style="width:100%;">
                                    <td :colspan="col" style="width:100%;">
                                        <li class="cyan darken-4 white--text text-center mt-3"><b> &nbsp; Sector: {{registro}} </b></li>
                                        <div v-for="(item, index2) in sectores(registro)" :key="index2" style="display:block;" class="text-cyan darken-4 mt-2">
                                            <div class="d-block">
                                                <table style="table-layout: fixed; width: 100%;">
                                                    <colgroup>
                                                        <col style="width: 10%;">
                                                        <col style="width: 37%;">
                                                        <col style="width: 38%;">
                                                        <col style="width: 5%;">
                                                        <col style="width: 10%;" v-if="esDeCalidad == true">
                                                    </colgroup>
                                                    <tr>
                                                        <td class="cyan lighten-2">{{ item.area }}</td>
                                                        <td class="cyan lighten-2 text-left">{{ item.orden }}.- {{ item.item }}</td>
                                                        <td class="cyan lighten-2 text-left">{{ item.detalle }}</td>
                                                        <td class="indigo lighten-3 text-center">
                                                            <v-btn v-if="item.tiene_archivos" title="ver archivo(s)" class="mx-2" small dark color="purple" icon
                                                                @click="cargarArchivos(item)"
                                                            >
                                                                <v-icon dark> collections </v-icon>
                                                            </v-btn>
                                                        </td>
                                                        <td v-if="esDeCalidad == true" class="cyan lighten-2">
                                                            <v-btn @click="cerrarNoConformidad(item, $event)" v-if="item.estado==0" small class="cyan darken-3 white--text" > Cerrar NC</v-btn>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <v-alert v-for="comentario in item.comentarios" :key="comentario.index" style="display:block; margin-bottom:2px;"
                                                border="top" color="blue" icon="comments" outlined dense type="success">
                                                    <table  style="table-layout: fixed; width: 100%;">
                                                        <colgroup>
                                                            <col style="width: 12%;">
                                                            <col style="width: 18%;">
                                                            <col style="width: 50%;">
                                                            <col style="width: 19%;">
                                                        </colgroup>
                                                        <tr style="color:#00897B;">
                                                            <td class="cyan lighten-5">{{ comentario.fecha }}</td>
                                                            <td class="cyan lighten-5 text-left">{{ comentario.usuario.name }}</td>
                                                            <td class="cyan lighten-5 text-left">{{ comentario.comentario }}</td>
                                                            <td class="cyan lighten-5 text-left">
                                                                <template v-for="archivo in comentario.archivos">
                                                                    <a :key="archivo.index" @click="showFile(archivo)" v-if="esDeCalidad == true">
                                                                        <v-btn v-if="item.tiene_archivos" class="mx-2" :title="archivo.nombre" small dark color="indigo" icon @click="showFile(archivo)" >
                                                                            <v-icon dark> collections </v-icon>
                                                                        </v-btn>
                                                                    </a>
                                                                    <a :key="archivo.index" v-if="esDeCalidad == false">
                                                                        <v-btn v-if="item.tiene_archivos" class="mx-2" :title="archivo.nombre" small dark color="indigo" icon @click="showFile(archivo)" >
                                                                            <v-icon dark> collections </v-icon>
                                                                        </v-btn>
                                                                    </a>
                                                                </template>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </v-alert>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="areaDialog" persistent max-width="90%">
            <v-card>
                <v-card-title>
                    <span class="headline">No conformidades de mi area ( Inspección fecha: {{ insp_actual.fecha | formatearFecha }} )</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="areaDialog = false"> VOLVER </v-btn>
                </v-card-actions>
                <v-card-text>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr width="100%">
                                    <th :width="item.width" v-for="item in area_headers" :key="item.name">{{ item.text }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(registro, index) in registros_areas" :key="index" width="100%">
                                    <td colspan="5" style="width:100%;">
                                        <li class="light-blue darken-4  mt-3 white--text text-center"><b> &nbsp; Sector: {{registro}} </b></li>
                                        <div v-for="(item, index2) in sectores(registro)" :key="index2" class="d-block  mt-2">
                                            <div class="d-block">
                                                <table  style="table-layout: fixed; width: 100%;">
                                                    <colgroup>
                                                        <col style="width: 10%;">
                                                        <col style="width: 35%;">
                                                        <col style="width: 40%;">
                                                        <col style="width: 5%;">
                                                        <col style="width: 10%;">
                                                    </colgroup>
                                                    <tr>
                                                        <td class="indigo lighten-3">{{ item.area }}</td>
                                                        <td class="indigo lighten-3 text-left">{{ item.orden }}.- {{ item.item }}</td>
                                                        <td class="indigo lighten-3 text-left">{{ item.detalle }}</td>
                                                        <td class="indigo lighten-3 text-center">
                                                            <v-btn v-if="item.tiene_archivos" class="mx-2" small dark color="purple" icon
                                                                @click="cargarArchivos(item)"
                                                            >
                                                                <v-icon dark> collections </v-icon>
                                                            </v-btn>
                                                        </td>
                                                        <td class="indigo lighten-3 text-left">
                                                            <v-btn dark small color="blue lighten-2" @click="showComentario(item,index2)">Comentar</v-btn>
                                                        </td>
                                                    </tr>
                                                </table>
                                                <v-alert v-for="comentario in item.comentarios" :key="comentario.index" style="display:block; margin-bottom:2px;"
                                                border="top" color="blue" icon="comments" outlined dense type="success">
                                                    <table  style="table-layout: fixed; width: 100%;">
                                                        <colgroup>
                                                            <col style="width: 12%;">
                                                            <col style="width: 18%;">
                                                            <col style="width: 50%;">
                                                            <col style="width: 19%;">
                                                        </colgroup>
                                                        <tr>
                                                            <td class="indigo lighten-5">{{ comentario.fecha }}</td>
                                                            <td class="indigo lighten-5 text-left">{{ comentario.usuario.name }}</td>
                                                            <td class="indigo lighten-5 text-left">{{ comentario.comentario }}</td>
                                                            <td class="indigo lighten-5 text-left">
                                                                <template v-for="archivo in comentario.archivos">
                                                                    <a :key="archivo.index" @click="showFile(archivo)">
                                                                        <v-btn v-if="item.tiene_archivos" class="mx-2" small dark color="indigo" icon @click="showFile(archivo)" >
                                                                            <v-icon dark> collections </v-icon>
                                                                        </v-btn>
                                                                    </a>
                                                                </template>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </v-alert>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>                
            </v-card>
        </v-dialog>
        <v-dialog v-model="comentarioDialog" persistent max-width="800px">
            <v-card>
                <v-card-title>
                    <span class="headline">Agregar Comentario</span>
                </v-card-title>
                <v-card-text>
                    <v-textarea
                        clearable
                        clear-icon="mdi-close-circle"
                        label="Comentario"
                        counter="500"
                        v-model="comentario"
                    >
                    </v-textarea>
                    <v-file-input
                        counter
                        ref="input_archivo"
                        multiple
                        show-size
                        truncate-length="15"
                        accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx"
                        small-chips
                        label="Archivos de respaldo"
                        @change="setear_archivos_comentario($event)"
                    ></v-file-input>
                    <input type="hidden" v-model="pac_registro_inspecciones_id" />
                    <input type="hidden" v-model="fila" />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="comentarioDialog = false"
                    >
                        Cerrar
                    </v-btn>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="agregarComentario"
                    >
                        Grabar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- ver imagenes -->
        <v-dialog v-model="imagenDialog" persistent width="90%">
            <v-card>
                <v-card-title>
                    <span class="headline">Imagen</span>
                    <v-card-actions>

                        <v-spacer></v-spacer>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="imagenDialog = false"
                        >
                            Cerrar
                        </v-btn>
                    </v-card-actions>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-col cols="10" class="body-2">
                            *Solo el usuario que sube una imagen puede eliminarla
                        </v-col>
                        <v-col cols="1">
                            <v-btn
                                color="red darken-1"
                                @click="deleteImg()"
                            >
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-card-actions>

                </v-card-title>
                <v-card-text>
                    <img :src="path" alt="imagen archivo"/>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="imagenDialog = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Visualizador de Archivos -->
        <v-dialog
            v-model="dialog_archivos"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-card>
                <v-toolbar
                    dark
                    color="primary"
                >
                <v-btn
                    icon
                    dark
                    @click="dialog_archivos = false"
                >
                    <v-icon>close</v-icon>
                </v-btn>
                
                </v-toolbar>
                
                <v-divider></v-divider>
                <v-list
                three-line
                subheader
                >
                <v-subheader>Archivos Subidos</v-subheader>
                <!-- <v-subheader>
                    <v-row>
                    <v-col>
                        <v-btn dark icon color="red darken-1" @click="eliminarImagenes()"><v-icon>delete</v-icon></v-btn> Eliminar Seleccionados
                    </v-col>
                </v-row>
                </v-subheader> -->
                
                <v-row class="ml-1 mr-1">
                    <v-col v-for="a in archivos_item" :key="a.id" align="center">
                        <v-img
                                style="cursor:pointer;"
                                max-height="150"
                                max-width="250"
                                :src="a.url"
                                @click="abrirImagen(a.url)"
                                ></v-img>
                        
                    </v-col>
                </v-row>
                </v-list>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import ModalAyudas from '../../components/shared/ModalAyudas.vue';

export default {
    data:()=>({
        imagenDialog: false,
        todoDialog: false,
        areaDialog: false,
        comentarioDialog: false,
        url_excel: '',
        formData: null,
        comentario: '',
        pac_registro_inspecciones_id: 0,
        fila: 0,
        fila_comment: 0,
        path: '',
        insp_actual:{},
        encabezados: [
            {
                text:'Fecha Inspección',
                align:'center',
                sortable:true,
                value:'fecha',
                class:'cabecera'
            },
            {
                text:'Realizada por',
                align:'center',
                sortable:true,
                value:'realizada_por',
                class:'cabecera'
            },
            {
                text:'N.C. Total',
                align:'center',
                sortable:false,
                value:'no_conformidad_total',
                class:'cabecera'
            },
            {
                text:'N.C. Area Actual',
                align:'center',
                sortable:false,
                value:'no_conformidad_area',
                class:'cabecera'
            },
            {
                text:'Ver Todo',
                align:'center',
                sortable:false,
                value:'todo',
                class:'cabecera'
            },
            {
                text:'Ver Area',
                align:'center',
                sortable:true,
                value:'area',
                class:'cabecera'
            },
            {
                text:'Imprimir',
                align:'center',
                sortable:false,
                value:'imprimir',
                class:'cabecera'
            },
            {
                text:'NC Area',
                align:'center',
                sortable:false,
                value:'nc_area',
                class:'cabecera'
            },
        ],
        inspecciones: [],
        todo_headers: [
            {text:'Area Responsable', align:'center', sortable:true, width:'10%', value:'area'},
            {text:'Ítem', align:'left', sortable:true, width:'37%', value:'item'},
            {text:'Descripción', align:'left', sortable:true, width:'38%', value:'descripcion'},
            {text:'Imagen', align:'left', sortable:false, width:'5%', value:'imagen'},
        ],
        todo_items: [],
        area_headers: [
            {text:'Area Responsable', align:'center', sortable:true,  width:'10%', value:'area'},
            {text:'Ítem', align:'left', sortable:true,  width:'35%', value:'item'},
            {text:'Descripción', align:'left', sortable:true, width:'40%', value:'descripcion'},
            {text:'Archivos', align:'center', sortable:true,  width:'5%', value:'tiene_archivos'},
            {text:'Opciones', align:'center', sortable:true,  width:'10%', value:'comentar'},
        ],
        area_items: [],
        archivos_item: [],
        dialog_archivos: false,
        archivo_actual:'',
        esDeCalidad: false
    }),
    mounted(){
        this.fechas = this.moment().format('YYYY-MM-DD');
        this.cargarLista();
        this.formData = new FormData();
        console.log("usuario", this.permisos_prod)
        let c = this.permisos_prod.filter(r => {
            return r.id == 5 
        });
        if(c.id != undefined){
            this.esDeCalidad = true;
            console.log("es de calidad");
        } else {
            if(c[0] != null){
                if(c[0].id != undefined){
                    this.esDeCalidad = true;
                    console.log("es de calidad");
                } else {
                    console.log("no es de calidad");
                }
            } else {
                console.log("no es de calidad");
            }
        }
    },
    methods:{
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Listado de Inspecciones`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestran todas las inspecciones registradas en el sistema. Al abrir la página, se cargarán todas las inspecciones del sistema, y los datos relacionados a cada una:`},
                {   tipo:`label`,   texto:`- Fecha (Fecha Inspección), quién la realizó (Realizada Por), la cantidad total de no conformidades (N.C. Total), la cantidad de no conformidades del área actual (N.C. Area Actual), un botón para ver la inspección con todos sus detalles (Ver Todo), un botón para ver las no conformidades del área actual (Ver Area), un botón para exportar a Excel la inspección (Imprimir) y otro para las no conformidades del Área (NC Area).`},
            ];
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cerrarNoConformidad(item, event){
            let url = `${this.base_url}cerrar_registro`;
            await this.axios.post(url, item, this.headers).then((response)=>{
                if(response.data == 1){
                    event.target.parentElement.remove();
                }
            }).catch((error)=>{
                console.log('error', error);
            });
        },
        
        showFile(archivo){
            console.log("showFile",archivo);
            this.archivo_actual = archivo.id;
            let le_path = archivo.path_minimized ? archivo.path_minimized : archivo.path;
            this.path = this.download_url.replace('bitacoras', 'inspecciones/imagenes') + le_path;
            this.imagenDialog = true;
        },
        async deleteImg(){
            let le_file = {archivo: this.archivo_actual}
            await this.axios.post(`${this.base_url}pac_inspeccion/eliminar_archivo_coment`, le_file, this.headers).then((res) => {
                console.log("res.data.message",res.data.message)
                if (res.data.message == "Archivo Eliminado") {
                    this.cargarUnaInspeccion(this.insp_actual.inspeccion_id,false);
                    this.imagenDialog = false;
                } else {
                    this.mostrarLoading({titulo:res.data.message,color:'green'});
                }
            }).catch((e)=>{
                this.mostrarLoading({titulo:'Error...'+e,color:'red'})
                console.log('ERROR:', e);
            });
        },
        async cargarLista(){
            //this.mostrarLoading('Cargando Lista...');
            this.mostrarLoading({titulo:'Cargando Lista...',color:'green'})

            let url = `${this.base_url}listar_inspecciones`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.inspecciones = response.data;
                this.url_excel = response.data.url_excel;
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        async download(item){
            let url = `${this.base_url}imprimir_excel/${item.inspeccion_id}`;
            await this.axios.get(url,this.headers).then((response)=>{
                window.location.href = this.download_url.replace('bitacoras', 'inspeccion_pac') + response.data;
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        async ncArea(item){
            let url = `${this.base_url}imprimir_excel_area/${item.inspeccion_id}`;
            await this.axios.get(url,this.headers).then((response)=>{
                window.location.href = this.download_url.replace('bitacoras', 'inspeccion_pac') + response.data;
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },

        async cargarUnaInspeccion(id,todo=true){
            this.mostrarLoading({titulo:'Cargando Inspección...',color:'green'})

            let url = `${this.base_url}listar_una_inspeccion/${id}`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.insp_actual = response.data;
                if(todo){
                    this.todo_items = response.data.todo;
                } else {
                    this.area_items = response.data.area;
                    this.todo_items = response.data.area;    
                }
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        verTodo(item){
            this.todoDialog = true;
            this.cargarUnaInspeccion(item.inspeccion_id);
        },
        verArea(item){
            this.areaDialog = true;
            this.cargarUnaInspeccion(item.inspeccion_id,false);
        },
        setear_archivos_comentario(files){
            files.forEach(f => {
                console.log(f);
                this.formData.append('files[]', f);
            });
        },
        showComentario(item){
            this.comentarioDialog = true;
            this.pac_registro_inspecciones_id = item.registro_id;
            const index = this.area_items.indexOf(item);
            this.fila_comment = index;
            this.comentario = '';
            if(this.$refs.input_archivo != null) {
                this.$refs.input_archivo.value=null;                
            }
        },
        async agregarComentario(){
            this.formData.append('pac_registro_inspecciones_id', this.pac_registro_inspecciones_id);
            this.formData.append('comentario', this.comentario);
            await this.axios.post(`${this.base_url}agregar_comentario_archivos`, this.formData, this.headers).then((res) => {
                if(res.status == 200 || res.status == 201){
                   /* let arraycito = new Array();
                    res.data.archivos.forEach(element => {
                        arraycito.push({nombre:element});
                    });*/
                    //console.log("test",arraycito , "res",res, res.data.archivos);
                   // let arr_user = {name:"yo"};
                    //this.area_items[this.fila_comment].comentarios.push({comentario:this.comentario, usuario:arr_user, archivos:arraycito});
                    this.formData = new FormData();
                    this.comentarioDialog = false;
                    this.cargarUnaInspeccion(this.insp_actual.inspeccion_id,false);
                }
            }).catch((e)=>{
                console.log('ERROR:', e);
            })
        },

        async cargarArchivos(item,index){
            //console.log("cargarArchivos",item)
            await this.axios.get(`${this.base_url}pac_registro_inspeccion/${item.registro_id}/cargar_archivos`,this.headers).then((res)=>{
                this.archivos_item = res.data.data;
            }).catch((e)=>{
                console.log(e);
            });
            this.dialog_archivos = true;
        },

        abrirImagen(url){
            window.open(url);
        },

        sectores(sector) {
            console.log(sector);
            let datito = this.todo_items
                .filter(fila => fila.sector === sector);
                console.log(datito);
            return datito;

        },

        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },
    computed: {
        registros() {
            const registros = new Set();
            this.todo_items.forEach(sectores => registros.add(sectores.sector));
            console.log(registros);
            return Array.from(registros); 
        },
        registros_areas() {
            const registros_areas = new Set();
            this.area_items.forEach(sectores => registros_areas.add(sectores.sector));
            console.log(registros_areas);
            return Array.from(registros_areas); 
        },
        col(){
            return this.esDeCalidad == true ? 5 : 4;
        },
        ...mapState(['user', 'permisos_prod', 'base_url', 'headers', 'download_url']),
    },
    components:{
        'modal-ayuda': ModalAyudas,
    }
}
</script>